import api from "./utils/api";
import browser from "./utils/browser";
import getScript from "./utils/get-script";
import tracking from "./utils/tracking";
import general from "./utils/general";
import history from "./utils/history";
import string from "./utils/string"
import storage from "./utils/storage";
import url from "./utils/url";

// @ts-ignore
const imkt: { [property: string]: any } = window.imkt = window.imkt || {
    core: {
        /*
         * this parses the DOM and finds any type="text/x-component" scripts and initializes a component for each
         */
        init: async function (domRoot: HTMLElement) {
            var self = this;

            this.featureDetect();

            const LocalizedPricing = (await import("./utils/localized-pricing")).default;

            const localizedPricing = new LocalizedPricing();

            $("script[type='text/x-component']", domRoot).each(function (i, elem) {
                var componentInfo = JSON.parse(elem.innerHTML.trim()),
                    componentRoot = elem.parentNode;

                const {
                    productKey,
                    productKeyArray,
                    period,
                    offeringSku,
                    countryISOCodeReq,
                } = componentInfo.params;

                if (productKey) {
                    componentInfo.params.pricing = localizedPricing.getPricingPromise(
                        productKey,
                        period
                    );
                }

                if (offeringSku) {
                    componentInfo.params.pricing = localizedPricing.getPricingPromise(
                        null,
                        period,
                        null,
                        null,
                        offeringSku
                    );
                }

                if (productKeyArray) {
                    componentInfo.params.pricingObject = productKeyArray.map((product: any) => {
                        return localizedPricing.getPricingPromise(
                            product.key,
                            product.period,
                            product.identifiers,
                            product.customCurrency,
                            product.offeringSku
                        );
                    });
                }

                if (countryISOCodeReq) {
                    componentInfo.params.countryISOCodePromise =
                        localizedPricing.getLocale();
                }

                try {
                    self.componentInit.call(self, componentRoot, componentInfo);
                } catch (e) {
                    console.log(e);
                }
            });

            localizedPricing.resolvePricingPromises();

            // Init component scripts with Smartling Translation
            $("script[type='text/x-component-translate']", domRoot).each(function (
                i,
                elem
            ) {
                var innerHTML = elem.innerHTML
                    .trim()
                    .replace("/* <sl:translate_json> */", "")
                    .replace("/* </sl:translate_json> */", "");
                var componentInfo = JSON.parse(innerHTML),
                    componentRoot = elem.parentNode;
                self.componentInit.call(self, componentRoot, componentInfo);
            });

            $(document).trigger("appInitialized");
            this.appInitialized = true;
        },
        onInitialized(cb) {
            if (this.appInitialized) {
                cb();
            } else {
                $(document).on("appInitialized", cb);
            }
        },
        featureDetect() {
            var bodyClasses = [];
            if (!this.supports.svg()) {
                bodyClasses.push("no-svg");
            }
            if (!this.supports.backgroundSize()) {
                bodyClasses.push("no-backgroundsize");
            }
            if (!this.supports.flexBox()) {
                bodyClasses.push("no-flexbox");
            }
            $("body").addClass(bodyClasses.join(" "));
        },
        extend(supertype, subtype, overrides = {}) {
            var ctor = function () { },
                name;
            ctor.prototype = supertype.prototype;
            subtype.prototype = new ctor();
            for (name in overrides) {
                subtype.prototype[name] = overrides[name];
            }
            subtype.prototype.constructor = supertype;
        },
        /*
         * this takes a namespaced string like "imkt.components.tabs" and returns the actual JS object (if found)
         */
        resolve(str, createIfNotExists) {
            var basis = window;
            if (!str) {
                return null;
            } else if (typeof str === "function") {
                return str;
            } else {
                var last = basis,
                    names = str.split("."),
                    name,
                    i,
                    j;
                for (i = 0, j = names.length; i < j; i++) {
                    name = names[i];
                    basis = basis[name];
                    if (!basis) {
                        if (createIfNotExists) {
                            basis = last[name] = {};
                        } else {
                            return null;
                        }
                    }
                    last = basis;
                }
            }
            return basis;
        },
        /*
         * tries to resolve the component name and if so, initializes it
         */
        componentInit(componentRoot, componentInfo) {
            var componentType = this.resolve(componentInfo.type);
            if (componentType) {
                return new componentType(
                    componentRoot,
                    Object.assign({}, componentInfo.params, $(componentRoot).data())
                );
            } else {
                // could not find component
            }
        },
        supports: {
            flexBox() {
                return (
                    "flexWrap" in document.documentElement.style ||
                    "webkitFlexWrap" in document.documentElement.style
                );
            },
            history() {
                return window.history && window.history.pushState;
            },
            svg() {
                return document.implementation.hasFeature(
                    "http://www.w3.org/TR/SVG11/feature#Image",
                    "1.1"
                );
            },
            backgroundSize() {
                return "backgroundSize" in document.documentElement.style;
            },
            touch() {
                return "ontouchstart" in window;
            },
            placeholder() {
                var i = document.createElement("input");
                return "placeholder" in i;
            },
            localStorage() {
                // Bugfix WTF-15606, try/catch for localStorage empty object (private browsers)
                try {
                    window.localStorage.setItem("hasStorage", "1");
                    return (
                        window.localStorage &&
                        window.localStorage.setItem &&
                        window.localStorage.removeItem
                    );
                } catch (error) {
                    return false;
                }
            },
            transitions() {
                var b = document.body || document.documentElement,
                    s = b.style,
                    p = "transition";

                if (typeof s[p] == "string") {
                    return true;
                }

                // Tests for vendor specific prop
                var v = ["Moz", "webkit", "Webkit", "Khtml", "O", "ms"];
                p = p.charAt(0).toUpperCase() + p.substr(1);

                for (var i = 0; i < v.length; i++) {
                    if (typeof s[v[i] + p] == "string") {
                        return true;
                    }
                }

                return false;
            },
        },
        is: {
            mobile() {
                return imkt.core.supports.touch() && screen.width && screen.width < 768;
            },
        },
    },
    utils: {
        api,
        browser,
        getScript,
        tracking,
        general,
        history,
        string,
        storage,
        url,
    },
    wpl: {
        globals: {
            mediaQueries: {
                "xs": { "minWidth": 0, "maxWidth": 539 },
                "sm": { "minWidth": 540, "maxWidth": 767 },
                "md": { "minWidth": 768, "maxWidth": 1023 },
                "lg": { "minWidth": 1024, "maxWidth": 1439 },
                "xl": { "minWidth": 1440, "maxWidth": null }
            }
        }
    },
    common: {},
    wac: {},
    landing: {},
    experts: {},
    legal: {},
    components: {},
    software: {},
    bxp: {},
    customers: {},
    pages: {},
    teamPatterns: {},
};

export default imkt;